export default class EventNames {
  public static get OCSDKLOAD(): string { return "oc:sdk:load"; }
}
